export const COMBINI_FEE = 390;
